/**
 * Business logic per Purchase Orders autocomplete
 * Pura - senza dipendenze da Vue
 */

import { isArray } from 'lodash-es';
import purchaseOrdersService from '../services/purchaseOrdersService';
import type { PurchaseOrderAutocompleteResult } from '../models/purchaseOrder';
import type { BaseAutocompleteOptions, ODataQueryBuilder } from './types';
import type { ODataContext } from '~/mixins/filterHandler/types';

export async function getPurchaseOrdersAutocomplete(
	buildQuery: ODataQueryBuilder,
	options: BaseAutocompleteOptions = {},
): Promise<PurchaseOrderAutocompleteResult[]> {
	const { searchString = '', id = null, notInIds = null } = options;

	const context: ODataContext = {
		select: 'id,code,name',
		count: true,
		top: 20,
		orderBy: ['code desc'],
		filter: { and: [] },
	};

	if (searchString !== '') {
		context.filter!.and!.push({
			or: [
				{ 'tolower(code)': { contains: searchString } },
				{ 'tolower(name)': { contains: searchString } },
			],
		});
	} else if (id) {
		context.filter!.and!.push({ id: { eq: id } });
	}

	if (notInIds && isArray(notInIds) && notInIds.length > 0) {
		context.filter!.and!.push({
			not: [{ id: { in: notInIds } }],
		});
	}

	const result = await purchaseOrdersService.getPurchaseOrders(buildQuery(context));
	// OData select: id, code, name - type safety garantita da Pick<>
	return result.value;
}
